import { keyframes } from 'styled-components'

const fadeIn = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.52);
  }
`
const fadeOut = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 0.52);
  }
  100% {
    background-color: rgba(0, 0, 0, 0);
  }
`

const down = keyframes`
  0% {
    top: -30%;
    opacity: 0;
  }
  100% {
    top: 30%;
    opacity: 1;
  }
`

const up = keyframes`
  0% {
    top: 30%;
    opacity: 1;
  }
  100% {
    top: -30%;
    opacity: 0;
  }
`

export { fadeIn, fadeOut, down, up }
